import React from 'react';

import { useUserCardLoader } from 'features/users/hooks/useUserCardLoader';

import { UserComponent, Props as UserComponentProps } from './UserComponent';
import { UserPlaceholder } from './UserPlaceholder';

type Props = Pick<UserComponentProps, 'className' | 'onMount'> & {
  userId: number;
  cacheKey?: string;
};

export const User: React.FC<Props> = ({ userId, cacheKey, ...props }) => {
  const user = useUserCardLoader(userId);

  return user ? (
    <UserComponent user={user} {...props} />
  ) : (
    <UserPlaceholder className={props.className} />
  );
};
